/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { observer } from 'mobx-react-lite';
import { LoginBaseLayout, useGlobalAppData } from '@veeam-vspc/shared/components';

import { useImageLoader, usePortalFaviconImage } from 'views/hooks';
import { useLoginStore } from '../../hooks';

export interface Props {
    children: React.ReactElement;
}

export const LoginBackground = observer(({ children }: Props) => {
    const appStore = useGlobalAppData();
    const loginStore = useLoginStore();
    const { image: brandImage } = useImageLoader(loginStore.productImageSrc);
    const { image: brandLogo } = useImageLoader(loginStore.productLogoImageSrc);

    usePortalFaviconImage(true);

    return (
        <LoginBaseLayout
            minWidth={appStore.appMinWidth}
            minHeight={appStore.appMinHeight}
            productBrandImage={brandImage}
            productIconLogo={brandLogo}
            title={appStore.portalName}
        >
            {children}
        </LoginBaseLayout>
    );
});
